export default __webpack_public_path__ + "static/media/icon-8.1952b380.png";